<template>
  <form
    v-if="!loading"
    class="row"
    @submit.prevent="saveSorting"
  >
    <h2 style="margin-left: 15px;">
      <router-link
        :to="{ name: 'coach-dashboard' }"
      >
        Dashboard
      </router-link>
      | Reorder Assignments for {{ selectedGroup.name }}
    </h2>

    <div style="padding: 20px;">
      <div class="row">
        <div class="col-sm-8">
          <h4
            style="margin-top: 0;"
          >
            Reorder your assignments by dragging and dropping the assignment
            cards into the desired order then click Save below.
          </h4>
        </div>
      </div>

      <div class="row assignmentSortingDiv">
        <draggable
          v-model="clonedAssignments"
          @end="sortingChanged"
        >
          <span
            v-for="assignment in clonedAssignments"
            :ref="'assignment-' + assignment.assignmentId"
            class="col-xs-6 col-sm-4 assignment"
          >
            <strong>
              <span class="assignmentName">
                {{ assignment.derivedSortOrder }}: {{ assignment.name | truncate25 }}
              </span>
            </strong>
            <div
              class="assignment-status"
            >
              Status: {{ getStatus(assignment) }}
            </div>
            <div
              class="assignment-description"
            >
              {{ assignment.description }}
            </div>
          </span>
        </draggable>
      </div>
      <br>
      <router-link
        :to="{ name: 'coach-dashboard' }"
      >
        <button
          type="button"
          class="btn clear-btn"
        >
          Cancel / Previous
        </button>
      </router-link>
      <loading-button
        style="float:right"
      >
        Save
      </loading-button>
    </div>
  </form>
  <div
    v-else
    class="text-center"
  >
    <h2>
      <svg
        class="icon-refresh rotate large-spinner"
      >
        <use xlink:href="/static/svg-symbols.svg#icon-refresh" />
      </svg>
      Loading...
    </h2>
  </div>
</template>

<style lang="less" scoped>
@import '../../less/bootstrap-vars.less';
@import '~bootstrap/less/mixins/buttons.less';

.assignmentSortingDiv { padding: 0 20px; }

.icon-comment, .icon-eye-slash, .icon-refresh, .icon-flag, .icon-microphone, .icon-checkmark {
  color: #333;
  width: 14px; height: 14px;
}
.rTable { display: table; width: 100%}
.rTableRow { display: table-row; }
.rTableCell {
  display: table-cell; width: 16%; text-align: center; font-size: 5pt;
  span {
    font-size: 9px;
  }
}
.rTableCellBorder { border-right: 1px solid grey; }
hr {
  margin: 5px;
}
.assignmentName {
  font-size: 9pt;
}
.assignment-status {
  font-size: 6pt;
}
.assignment-description {
  font-size: 8pt;
}
.attachmentsLink {
  font-size: 10px;
  color: gray;
  text-decoration: none;
  span {
    position: relative;
    bottom: 2px;
    left: 2px;
  }
}
.attachmentsLinkContainer {
  border-bottom: 1px solid grey;
}
.assignment {
  height: 91px;
  width: 200px;
  border: 1px solid #ede9e8;
  margin: 10px 20px 10px 0;
  padding: 4px;
  background-color: #f2f2f2;
  overflow: hidden;
  cursor: grab;
}
.assignmentIcon {
  position: relative;
  top: 2px;
}
.assignment-description {
  font-size: 8pt;
  height: 60px;
  padding-bottom: 0;
  overflow: hidden;
  border-top: 1px solid grey;
}
</style>

<script>
import Draggable from 'vuedraggable';
import service from '../../services/assignments';
import BasePage from '../pages/BasePage';
import AssignmentDataStructures from '../specials/AssignmentDataStructures';
import ScorecardMixin from '../specials/ScorecardMixin';
import CoachDashboardJs from '../specials/CoachDashboardJs';
import TableMethods from '../specials/TableMethods';

export default {
  components: { Draggable },
  mixins: [BasePage, AssignmentDataStructures, CoachDashboardJs, TableMethods, ScorecardMixin],
  data() {
    return {
      loading: true,
      clonedAssignments: [],
    };
  },
  computed: {
    assignmentStepsByName() {
      return this.$store.getters.appConfig.assignmentStepsByName;
    }
  },
  methods: {
    basePageCreated() {
      this.selectedGroup = this._.find(this.managedGroups, {groupId: this.$router.currentRoute.params.groupId});
      const assignmentsLoaded = !!(this.$store.getters.assignments && this.$store.getters.assignments.length);
      if (assignmentsLoaded) {
        this.clonedAssignments = this._.cloneDeep(this.sortableGroupAssignments);
        return this.loading = false;
      }
      this.loadAllAssignmentsData(true).then(() => {
        this.clonedAssignments = this._.cloneDeep(this.sortableGroupAssignments);
        this.loading = false;
      });
    },
    sortingChanged: function() {
      // Update derivedSortOrder
      let i = 1;
      this._.forEach(this.clonedAssignments, (ass) => ass.derivedSortOrder = i++);
    },
    closeSorting() {
      this.$emit('closeSorting');
    },
    saveSorting() {
      const assignments = this._.map(this.clonedAssignments, (ass) => {
        return {
          assignmentId: ass.assignmentId,
          sortOrder: ass.derivedSortOrder,
        };
      });
      service.reorderAssignments({assignments}).then(() => {
        window.setTimeout(() => {
          this.$store.dispatch('notify', {
            type: 'success',
            subject: 'Assignments Saved',
            text: 'The new order for your assignments has been saved.',
          });
        }, 1500);
        this.$router.push({name: 'coach-dashboard'});
      });
    },
    getStatus(assignment) {
      if (assignment.archived || assignment.deleted) {
        return 'Disabled/Archived';
      }
      let baseStatus = (assignment.assignmentAssignedCount == assignment.assignmentCompletedCount &&
        (!assignment.groupTargets || !assignment.groupTargets.length)) ?
        'Completed' : 'Active';
      if (assignment.groupTargets && assignment.groupTargets.length) {
        baseStatus += ' (Continuous Group Assignment)';
      } else {
        baseStatus += ' (Non-Continuous Assignment)';
      }
      return baseStatus;
    },
  }
};
</script>
